import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import OrdersPage from "@/pages/OrdersPage";
import OrderWizard from "@/pages/OrderWizard";
import OrderView from "@/pages/OrderView";
import ClientsPage from "@/pages/ClientsPage";
import ProductsPage from "@/pages/ProductsPage";
import PriceTablesPage from "@/pages/PriceTablesPage";
import RepresentativesPage from "@/pages/RepresentativesPage";
import SettingsPage from "@/pages/SettingsPage";
import MaterialsPage from "@/pages/MaterialsPage";
import CommissionsPage from "@/pages/CommissionsPage";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="h-8 w-8 rounded-full border-2 border-zinc-300 border-t-accent animate-spin" />
    </div>
  );
}

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/pedidos" replace />;
  return children;
}

function HomeRedirect() {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/dashboard" : "/pedidos"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<HomeRedirect />} />
            <Route element={<Protected><AppLayout /></Protected>}>
              <Route path="/dashboard" element={<Protected adminOnly><Dashboard /></Protected>} />
              <Route path="/pedidos" element={<OrdersPage />} />
              <Route path="/pedidos/novo" element={<OrderWizard />} />
              <Route path="/pedidos/:id" element={<OrderView />} />
              <Route path="/clientes" element={<ClientsPage />} />
              <Route path="/materiais" element={<MaterialsPage />} />
              <Route path="/produtos" element={<Protected adminOnly><ProductsPage /></Protected>} />
              <Route path="/tabelas" element={<Protected adminOnly><PriceTablesPage /></Protected>} />
              <Route path="/comissoes" element={<Protected adminOnly><CommissionsPage /></Protected>} />
              <Route path="/representantes" element={<Protected adminOnly><RepresentativesPage /></Protected>} />
              <Route path="/configuracoes" element={<Protected adminOnly><SettingsPage /></Protected>} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
